import { render } from "./EmpresaPresupuestos.vue?vue&type=template&id=446056ef&scoped=true"
import script from "./EmpresaPresupuestos.vue?vue&type=script&lang=js"
export * from "./EmpresaPresupuestos.vue?vue&type=script&lang=js"

import "./EmpresaPresupuestos.vue?vue&type=style&index=0&id=446056ef&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-446056ef"

export default script